import { useEffect, useState } from '../../common/common';
import axiosJWT from '../../secureAPI/axiosJWT';
import useGetUserData from '../../secureAPI/GetUserData';
import { StartLoading, StopLoading } from '../../Utils/loadingUtils';
import { showToast } from '../../Utils/toastUtils';
import { CartState } from '../../context/Context';
import { validateAddressForm } from '../../validation/Authentication/Validation';
import { useErrorContext } from '../../context/ErrorContext';
import Navigations from '../../common/useNavigation';

const MidSuppliersProducts = (supplier_id, type) => {

    const { users } = useGetUserData();
    const { navigateDashboard, handlenavigateBuyerOrders } = Navigations();
    const { setValidationError, clearAllErrors } = useErrorContext();
    const [products, setProducts] = useState([]);
    const [isLoading, setisLoading] = useState(false);
    const [fullscreen, setFullscreen] = useState(true);
    const [total, setTotal] = useState();
    const [totalitem, setTotalitem] = useState();
    const [addressData, setAddressData] = useState([]);
    const [custommessage, setCustommessage] = useState('');
    const [address, setAddress] = useState('');
    const [modalShow, setModalshow] = useState(false);
    const [addvalues, setAddValue] = useState(
        {
            addressTitle: "",
            address: "",
            active: 0,
            defaultAddress: 0
        }
    );
    const handlehideaddressmodal = () => {
        setModalshow(false);
    }

    useEffect(() => {
        const logUserData = () => {
            if (users?.length > 0 && type !== '') {
                const userTypes = users[0]['UserType'];
                const usertypeArray = typeof userTypes === 'string' ?
                    userTypes.split(',').map(str => parseInt(str.trim())).filter(num => !isNaN(num)) : [];

                const hasOne = usertypeArray.includes(1);
                const hasTwo = usertypeArray.includes(2);
                if (type === 'buyer' && users[0]['IsPersonalDetils'] === 1 && (hasOne || (hasOne && hasTwo))) { }
                else {
                    navigateDashboard('buyer');
                }
            }
        };

        if (Array.isArray(users) && users.length > 0) {
            logUserData();
        }
    }, [users, type]);

    // useEffect(() => {
    //     //  console.log('called useeffectsss');
    //     if (Array.isArray(users) && users.length > 0) {
    //         console.log('useEffect called, users:', users);
    //         logUserData();
    //     }
    // }, [users]);

    // const logUserData = () => {
    //     if (users?.length > 0) {
    //         if (type === 'buyer' && users[0]['IsPersonalDetils'] === 1 && (parseInt(users[0]['UserType']) === 1 || users[0]['UserType'] === '1,2')) {

    //         }
    //         else {
    //             navigateDashboard('buyer');
    //         }
    //     }
    // };
    useEffect(() => {
        getProductsVariant();
        getAdress();
    }, []);
    const { state: { cart }, dispatch, } = CartState();
    // const { state } = CartState();
    // useEffect(() => {
    //     console.log({cart:cart});
    //     // alert("set total call");
    //     setTotal(cart.reduce((acc, cur) => acc + Number(cur.shipping_unit * (cur?.priceDetails?.price || cur?.product_price) * cur.qty), 0))
    // }, [cart]);
    useEffect(() => {
        // console.log("Cart Items:");
        cart.forEach(item => {
            // console.log({
            //     variant: item.variant_unique_id,
            //     priceSource: item.priceSource,
            //     priceDetails: item.priceDetails,
            //     finalPrice: item?.priceDetails?.price || item.product_price,
            // });
        });

        setTotal(
            cart.reduce((acc, cur) => {
                const price = Number(cur?.priceDetails?.price || cur.product_price);
                return acc + cur.shipping_unit * price * cur.qty;
            }, 0)
        );
    }, [cart]);

    useEffect(() => {
        // alert("set total item call");
        setTotalitem(cart.reduce((acc, cur) => acc + Number(cur.qty), 0))
    }, [cart]);
    const handleshowaddressmodal = () => {
        setModalshow(true);
    }
    const getProductsVariant = async () => {
        StartLoading(setisLoading);

        try {
            await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/GetSellerProductVariations`, { supplier_id: supplier_id, app: 0 }, { withCredentials: true }).then((response) => {
                StopLoading(setisLoading);
                if (response.data.success === 1) {
                    setProducts(response.data.data);
                }
                else {
                    StopLoading(setisLoading);
                    showToast(response.data.message, 'error');
                }
            }).catch((err) => {
                StopLoading(setisLoading);
                showToast("Failed to find seller details 1, please try again later ", 'error');
            });
        } catch (err) {
            StopLoading(setisLoading);
            showToast("Failed to find seller details 2, please try again later ", 'error');
        }
    }
    // Reusable function to handle validation and set errors
    const validateAndSetErrors = (values) => {
        const validationErrors = validateAddressForm(values);
        Object.keys(validationErrors).forEach(field => setValidationError(field, validationErrors[field]));
        return validationErrors;
    };
    const handleAddressModalSubmit = (e) => {
        // alert('test');
        e.preventDefault();
        const { name, value } = e.target;
        setAddValue(prevValues => ({ ...prevValues, [name]: value }));
        setAddValue(prevValues => ({ ...prevValues, active: 0 }));
        const validationErrors = validateAndSetErrors(addvalues);
        if (Object.keys(validationErrors).length === 0) {
            clearAllErrors();
            addAddress();
        }
    };


    const addAddress = async () => {
        // alert('submit');
        if (addvalues.addressTitle !== '' && addvalues.address !== '') {
            StartLoading(setisLoading);

            try {

                await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/AddAddress`, { address_title: addvalues.addressTitle, address: addvalues.address, active: addvalues.active }, { withCredentials: true })
                    .then((response) => {
                        StopLoading(setisLoading);
                        if (response.data.success === 1) {
                            showToast(response.data.message, 'success');
                            setModalshow(false);
                            addvalues.addressTitle = '';
                            addvalues.address = '';
                            setTimeout(() => {
                                getAdress();
                            }, 2000);
                        }
                        else {
                            showToast(response.data.message, 'error');
                        }
                    })
                    .catch((err) => {
                        StopLoading(setisLoading);
                        showToast("Failed to find seller details, please try again later ", 'error');
                    });
            } catch (err) {
                StopLoading(setisLoading);
                showToast("Failed to find seller details, please try again later ", 'error');
            }
        }
        else {
            StopLoading(setisLoading);
            showToast("Failed to find seller details, please try again later ", 'error');
        }
    }

    const getAdress = async () => {
        try {
            await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/GetAddress`, { app: 0 }, { withCredentials: true })
                .then((response) => {
                    StopLoading(setisLoading);
                    if (response.data.success === 1) {
                        showToast(response.data.message, 'success');
                        setAddressData(response.data.data);
                    }
                    else {
                        showToast(response.data.message, 'error');
                    }
                })
                .catch((err) => {
                    StopLoading(setisLoading);
                    showToast("Failed to find seller details, please try again later ", 'error');
                });
        } catch (err) {
            StopLoading(setisLoading);
            showToast("Failed to find seller details, please try again later ", 'error');
        }
    }
    const handleaddressChange = e => {
        const { name, value } = e.target;
        setAddValue(prevValues => ({ ...prevValues, [name]: value }));
        if (Object.keys(validateAndSetErrors(addvalues)).length === 0) clearAllErrors();

    };
    const handleChange = (event) => {
        setAddress(event.target.value)
    }
    const handlenameChange = e => {
        setCustommessage(e.target.value)
    };

    const handleSubmit = e => {
        e.preventDefault();
        placeorder();
    }


    const placeorder = async () => {
        const custom_msg = custommessage;
        const deliveryAddress = address;

        if (address !== '') {
            StartLoading(setisLoading);

            try {
                const response = await axiosJWT.post(
                    `${process.env.REACT_APP_API_URL}/api/AddOrder`,
                    {
                        cartdata: cart,
                        custom_msg: custom_msg,
                        deliveryAddress: deliveryAddress,
                        app: 0
                    },
                    { withCredentials: true }
                );

                StopLoading(setisLoading);

                if (response.data.success === 1) {
                    showToast(response.data.message, 'success');
                    handlenavigateBuyerOrders();
                } 
            } catch (err) {
                StopLoading(setisLoading);
            }
        }
        else {
            setisLoading(false);
            showToast("Failed to find seller details, please try again later ", 'error');
        }
    };



    return { users, isLoading, products, fullscreen, setFullscreen, cart, dispatch, addressData, setAddressData, totalitem, total, handleshowaddressmodal, modalShow, setModalshow, handlehideaddressmodal, handleAddressModalSubmit, addvalues, handleaddressChange, handleChange, handlenameChange, handleSubmit }
}

export default MidSuppliersProducts